import type { Tab } from "types/tabs.types"

export const getSpanTabsConfig = (search: string): Tab[] => [
  {
    labelKey: "tabs.OVERVIEW",
    value: 0,
    to: { pathname: "", search },
  },
  {
    labelKey: "tabs.SETTINGS",
    value: 1,
    to: { pathname: "settings" },
  },
]
